export default "./search.svg"